var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPallets2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 626.53 487.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-14,.cls-2{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#a3866a;}.cls-2{stroke:#dcb998;}.cls-3{opacity:0.4;}.cls-4{fill:#d6c17a;}.cls-5{fill:#d6ad68;}.cls-6{fill:#c28e53;}.cls-7{fill:#a4743f;}.cls-8{fill:#845e38;}.cls-9{fill:#f2dac5;}.cls-10{fill:#c5a07d;}.cls-11{fill:#dcb998;}.cls-12{stroke:#fdebdd;}.cls-13{fill:#ded6ce;}.cls-14{stroke:#f2dac5;}.cls-15{fill:#6e6964;}.cls-16{fill:#87817d;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Pallet_01b",
    "data-name": "Pallet_01b",
    viewBox: "0 0 292 252.55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.05,107.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.8,127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.86,99.74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 85.55)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "36.45 147.68 122.9 197.59 255.9 154.38 169.45 104.46 36.45 147.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "122.9 197.59 36.45 147.68 36.45 165.68 49.75 173.36 49.75 161.36 73.02 174.79 73.02 186.79 86.32 194.47 86.28 182.5 109.6 195.91 109.6 207.91 122.9 215.59 122.9 197.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "255.9 154.38 255.9 172.38 122.9 215.59 122.9 197.59 255.9 154.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.62 190.15 86.32 194.47 86.28 182.47 99.62 190.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.05 169.03 49.75 173.36 49.75 161.36 63.05 169.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "182.75 184.14 182.75 190.14 136.2 205.27 136.2 199.27 182.75 184.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "182.75 190.14 176.1 186.3 182.75 184.14 182.75 190.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.6 164.7 242.6 170.7 196.05 185.82 196.05 179.82 242.6 164.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "242.6 170.7 235.95 166.86 242.6 164.7 242.6 170.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "166.12 0.54 242.6 44.7 122.9 83.59 46.42 39.44 166.12 0.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "242.6 44.7 122.9 83.59 122.9 191.59 242.6 152.7 242.6 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "122.9 83.59 122.51 191.46 46.42 147.44 46.42 39.44 122.9 83.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M189.4,99.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.91,110.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 202.7,
    y1: 57.66,
    x2: 206.02,
    y2: 164.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.8,
    y1: 70.62,
    x2: 166.12,
    y2: 177.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.9,
    y1: 83.59,
    x2: 122.9,
    y2: 191.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.42 147.44 122.9 191.59 242.6 152.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.9,
    y1: 137.59,
    x2: 242.6,
    y2: 98.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.85,84.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 186.07,
    y1: 12.06,
    x2: 66.37,
    y2: 50.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 222.65,
    y1: 33.18,
    x2: 102.95,
    y2: 72.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "142.85 83.11 129.55 87.43 129.55 99.43 142.85 95.11 142.85 83.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "182.75 70.14 169.45 74.46 169.45 86.46 182.75 82.14 182.75 70.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "222.65 57.18 209.35 61.5 209.35 73.5 222.65 69.18 222.65 57.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "142.85 137.11 129.55 141.43 129.55 153.43 142.85 149.11 142.85 137.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "182.75 124.14 169.45 128.46 169.45 140.46 182.75 136.14 182.75 124.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "222.65 111.18 209.35 115.5 209.35 127.5 222.65 123.18 222.65 111.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 83,
    y1: 60.55,
    x2: 83,
    y2: 168.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 46.42,
    y1: 96.44,
    x2: 122.9,
    y2: 137.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 46.42,
    y1: 147.44,
    x2: 46.42,
    y2: 39.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "46.42 39.44 166.12 0.54 242.6 44.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 202.7,
    y1: 21.66,
    x2: 83,
    y2: 60.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 86.32,
    y1: 26.47,
    x2: 162.8,
    y2: 70.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 126.22,
    y1: 13.51,
    x2: 202.7,
    y2: 57.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "106.27 73.99 99.62 190.15 92.97 186.31 99.62 70.15 106.27 73.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "225.97 35.1 219.32 31.26 99.62 70.15 106.27 73.99 225.97 35.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "69.7 52.87 63.05 169.03 56.4 165.2 63.05 49.03 69.7 52.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "189.4 13.98 182.75 10.14 63.05 49.03 69.7 52.87 189.4 13.98"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 292,
    height: 167,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "Pallet_01b-3",
    "data-name": "Pallet_01b",
    viewBox: "0 0 292 252.55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.05,107.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.8,127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.86,99.74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadow-2",
    "data-name": "shadow",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 85.55)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "36.45 147.68 122.9 197.59 255.9 154.38 169.45 104.46 36.45 147.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "122.9 197.59 36.45 147.68 36.45 165.68 49.75 173.36 49.75 161.36 73.02 174.79 73.02 186.79 86.32 194.47 86.28 182.5 109.6 195.91 109.6 207.91 122.9 215.59 122.9 197.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "255.9 154.38 255.9 172.38 122.9 215.59 122.9 197.59 255.9 154.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.62 190.15 86.32 194.47 86.28 182.47 99.62 190.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.05 169.03 49.75 173.36 49.75 161.36 63.05 169.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "182.75 184.14 182.75 190.14 136.2 205.27 136.2 199.27 182.75 184.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "182.75 190.14 176.1 186.3 182.75 184.14 182.75 190.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.6 164.7 242.6 170.7 196.05 185.82 196.05 179.82 242.6 164.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "242.6 170.7 235.95 166.86 242.6 164.7 242.6 170.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "166.12 0.54 242.6 44.7 122.9 83.59 46.42 39.44 166.12 0.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "242.6 44.7 122.9 83.59 122.9 191.59 242.6 152.7 242.6 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "122.9 83.59 122.51 191.46 46.42 147.44 46.42 39.44 122.9 83.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M189.4,99.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.91,110.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 202.7,
    y1: 57.66,
    x2: 206.02,
    y2: 164.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.8,
    y1: 70.62,
    x2: 166.12,
    y2: 177.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.9,
    y1: 83.59,
    x2: 122.9,
    y2: 191.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.42 147.44 122.9 191.59 242.6 152.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.9,
    y1: 137.59,
    x2: 242.6,
    y2: 98.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.85,84.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 186.07,
    y1: 12.06,
    x2: 66.37,
    y2: 50.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 222.65,
    y1: 33.18,
    x2: 102.95,
    y2: 72.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "142.85 83.11 129.55 87.43 129.55 99.43 142.85 95.11 142.85 83.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "182.75 70.14 169.45 74.46 169.45 86.46 182.75 82.14 182.75 70.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "222.65 57.18 209.35 61.5 209.35 73.5 222.65 69.18 222.65 57.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "142.85 137.11 129.55 141.43 129.55 153.43 142.85 149.11 142.85 137.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "182.75 124.14 169.45 128.46 169.45 140.46 182.75 136.14 182.75 124.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "222.65 111.18 209.35 115.5 209.35 127.5 222.65 123.18 222.65 111.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 83,
    y1: 60.55,
    x2: 83,
    y2: 168.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 46.42,
    y1: 96.44,
    x2: 122.9,
    y2: 137.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 46.42,
    y1: 147.44,
    x2: 46.42,
    y2: 39.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "46.42 39.44 166.12 0.54 242.6 44.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 202.7,
    y1: 21.66,
    x2: 83,
    y2: 60.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 86.32,
    y1: 26.47,
    x2: 162.8,
    y2: 70.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 126.22,
    y1: 13.51,
    x2: 202.7,
    y2: 57.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "106.27 73.99 99.62 190.15 92.97 186.31 99.62 70.15 106.27 73.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "225.97 35.1 219.32 31.26 99.62 70.15 106.27 73.99 225.97 35.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "69.7 52.87 63.05 169.03 56.4 165.2 63.05 49.03 69.7 52.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "189.4 13.98 182.75 10.14 63.05 49.03 69.7 52.87 189.4 13.98"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(142.32 127.03)",
    xlinkHref: "#Pallet_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(236.76 181.57)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(142.32)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(236.76 54.54)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(0 175.91)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(94.44 230.45)",
    xlinkHref: "#Pallet_01b-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 292,
    height: 252.55,
    transform: "translate(334.53 235.44)",
    xlinkHref: "#Pallet_01b-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallets2);
export default __webpack_public_path__ + "static/media/pallets-2.03146f299e8313120a0522cfc48b5060.svg";
export { ForwardRef as ReactComponent };